exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-5-wrapper[data-v-686f88a3]{width:242px;padding-bottom:10px}", ""]);

// exports
